import { getBytesCount_v2 } from "@utils/data"

const EMOJI_REGX = /[\u{1F600}-\u{1F64F}]|[\u{1F300}-\u{1F5FF}]|[\u{1F680}-\u{1F6FF}]|[\u{1F1E0}-\u{1F1FF}]|[\u{2600}-\u{26FF}]|[\u{2700}-\u{27BF}]|[\u{1F900}-\u{1F9FF}]|[\u{1FA00}-\u{1FA6F}]|[\u{1FA70}-\u{1FAFF}]|[\u{200D}]|[\u{FE00}-\u{FE0F}]|[\u{1F004}]|[\u{1F0CF}]|[\u{1F170}-\u{1F1FF}]/gu;

// 标题校验核心逻辑，返回 { valid, error }
export function checkTitleValid(value, { isHasNameFix, namePrefix }) {
    let title = value || '';
    if (isHasNameFix && namePrefix) {
        title = `${namePrefix}${value}`
    }
    if (/\s{2,}/.test(title)) {
        return { valid: false, error: '不能包含连续空格' };
    }
    if (EMOJI_REGX.test(title)) {
        return { valid: false, error: '商品标题不能包含表情符号' };
    }
    if (getBytesCount_v2(title) > 60) {
        return { valid: false, error: '最多输入30个字（60个字符）' };
    }
    if (getBytesCount_v2(title) < 15) {
        return { valid: false, error: '至少输入8个字（15个字符）' };
    }
    return { valid: true, error: '' };
}

const validateCategoryIds = (rule, value, callback) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (value.length === 0 || sum === 0) {
        callback(new Error('请选择类目'));
    } else {
        callback();
    }
}
const validateTitle = (rule, value, callback, context) => {
    const { valid, error } = checkTitleValid(value, {
        isHasNameFix: context.isHasNameFix,
        namePrefix: context.value.namePrefix
    });
    if (!valid) {
        callback(new Error(error));
    } else {
        callback();
    }
}
const validateShortTitle = (rule, value, callback, context) => {
    let title = (value || '').trim();
    if(!title) {
        callback();
    } else if (getBytesCount_v2(title) > 24) {
        callback(new Error('最多输入12个汉字（24个字符）'));
    } else {
        callback();
    }
}
const validateDescrip = (rule, value, callback) => {
    const regx = /^\uD83C[\uDF00-\uDFFF]|\uD83D[\uDC00-\uDE4F]$/;
    if (value) {
        if (regx.test(value)) {
            callback(new Error('不能含emoj表情'));
        } else if (value.length < 8 || value.length > 50) {
            callback(new Error('必须为8-50个汉字'))
        } else {
            callback();
        }
    } else {
        callback();
    }
    
}
const validateImages = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum < 1) {
        callback(new Error('至少要选择1张图片'));
    } else if (sum > 50) {
        callback(new Error('最多上传50张图片'));
    } else if(context.$refs.description_MutiImgUpload) {
        let errMsg = await context.$refs.description_MutiImgUpload.method_validImage();
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
}
const validateCertificateImages = async (rule, value, callback, context) => {
    let sum = 0;
    let errMsg = await context.$refs.certificate_urls.method_validImage();
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum < 1) {
        callback(new Error('至少要选择1张图片'));
    } else if(errMsg) {
        callback(new Error(errMsg));
    } else {
        callback();
    }
    
}
const validatePic = async (rule, value, callback, context) => {
    let sum = 0;
    if (value.length) {
        value.forEach(v => {
            if (v) sum++;
        })
    }
    if (sum < 3) {
        callback(new Error('至少要选择3张图片'));
    } if (sum > 5) {
        callback(new Error('最多上传5张图片'));
    }else if (context.$refs.pic) {
        let errMsg = await context.$refs.pic.method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
}
const validateDialogImageUrl = async (rule, value, callback, context) => {
    const dialogImageUrlRef = context.$refs.bg_MutiImgUpload
    if (dialogImageUrlRef) {
        let errMsg = await dialogImageUrlRef.method_validImage()
        if(errMsg) {
            callback(new Error(errMsg));
        }
    }
    callback();
}
const validatePic34 = async (rule, value, callback, context, refName) => {
    if(context.$refs[refName]){
        let errMsg = await context.$refs[refName].method_validImage()
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    }
}
const validatePrice = (rule, value, callback) => {
    value = String(value);
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (isNaN(valueNum)) {
        callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
    } else if (valueNum < 0) {
        callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
    } else if (idx !== -1 &&  mStr.length > 2) {
        callback(new Error('必须为大于等于0的正数且支持小数点后2位'));
    } else {
        callback();
    }
    
}
const validateWeight = (rule, value, callback) => {
    value = String(value);
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (isNaN(valueNum)) {
        callback(new Error('必须为大于等于0的正数且支持小数点后4位'));
    } else if (valueNum < 0) {
        callback(new Error('必须为大于等于0的正数且支持小数点后4位'));
    } else if (idx !== -1 && mStr.length > 4) {
        callback(new Error('必须为大于等于0的正数且支持小数点后4位'));
    } else {
        callback();
    }
    
}
const validateKefuPhone = (rule, value, callback) => {
    const regx = /^[0-9-]+$/
    if (value) {
        if (!regx.test(value)) {
            callback(new Error('仅支持数字和-，不允许超过32个字符'));
        } else {
            callback();
        }
    } else {
        callback();
    }
    
}

// 校验预售结束时间
// 不能超过当前时间的30天
const validatePresellEnd = (rules, value, callback, context) => {
    const data = context.value ? context.value : context.formData
    if(data.presellEndTimeType == 1){
        if(!data.presellEndTime){
            return callback(new Error(`请填写预售结束时间`))
        }
        if(data.presellEndTime>30){
            return callback(new Error(`最大时间为30天，请重新输入`))
        }
    } 

    // if (dayjs(value).diff(dayjs()) > context.deliveryAfterPresellConfig.maxPresellEndDays * 24 * 3600 * 1000) {
    //     return callback(new Error(`不能超过当前时间${context.deliveryAfterPresellConfig.maxPresellEndDays}天`))
    // }
    callback()
}

// 商品限购公共校验 // 都需要是正整数且取值范围是[1,200]，非必填
// 返回true需要继续走后续操作
// 返回false则校验不通过，或者是已满足特定条件（如非必填）需要终止后续操作
const _commonPBPO = (value, callback, success) => {
    if (!value && value !== 0) {
        // 非必填
        callback()
        success && success()
        return false
    }
    // 校验正整数
    let pass = true
    const num = Number(value)
    if (isNaN(num)) {
        // 数字
        pass = false
    } else if (/\./.test(String(value))) {
        // 整数
        pass = false
    } else if (1 > num) {
        // 大于等于1
        pass = false
    } else if (200 < num) {
        // 小于等于200
        pass = false
    }
    if (!pass) {
        callback(new Error('正整数且取值范围是[1,200]'))
        return false
    }
    return true

}
// 校验无理由退货服务的值是否是可选项中的值
const validateSupplyDayReturnSelector = (rule, value, callback, context) => {
    if(context.isLoadedProductUpdateRule) { // supplyDayReturnList加载出来之后再进行判断
        const isIn = context.supplyDayReturnList.find(item => item.value === value)
        if(!isIn) callback('当前选项不支持，请重新选择')
    }
    callback()
}
// 校验单用户累计限购
const validateLimitPB = (rule, value, callback, context) => {
    let pass = _commonPBPO(value, callback, () => {
        context.$refs?.form?.validateField(['maximumPerOrder', 'minimumPerOrder'])
    })
    if (!pass) return
    callback()
    context.$refs?.form?.validateField(['maximumPerOrder', 'minimumPerOrder'])
}
// 校验单用户每次限购
const validateMaxPO = (rule, value, callback, context) => {
    let pass = _commonPBPO(value, callback)
    if (!pass) return
    // 每次限购不能超过累计限购
    const limitPerBuyer = context.value.limitPerBuyer
    if (!limitPerBuyer) {
        // 为空值代表不限购
        return callback()
    }
    if (isNaN(Number(limitPerBuyer)) || Number(value) > Number(limitPerBuyer)) {
        return callback(new Error('不得超过累计限购数量'))
    }
    callback()
}
// 校验单用户每次至少购买
const validateMinPO = (rule, value, callback, context) => {
    let pass = _commonPBPO(value, callback)
    if (!pass) return
    // 单次至少购买不能超过累计限购
    const limitPerBuyer = context.value.limitPerBuyer
    if (!limitPerBuyer) {
        // 为空值代表不限购
        return callback()
    }
    if (isNaN(Number(limitPerBuyer)) || Number(value) > Number(limitPerBuyer)) {
        return callback(new Error('不得超过累计限购数量'))
    }
    callback()
}
// 检验发货时间
const validateDeliveryDelayDay = (rule, value, callback,context) => {
    if(context._data.timeSkuPresellWithNormalRule && context._data.timeSkuPresellWithNormalRule.support == true){

        const data = context._data.value?context._data.value:context._data.formData
        let _timeSpecList = data.timeSpecList.length?[...new Set(data.timeSpecList.map(item => Number(item)))].filter(item => item !== 0) : []
        if(_timeSpecList.length == 1 && [2].includes(Number(_timeSpecList)) && value.length == 0){
            _timeSpecList = []
        }
        // 如果是现货+预售模式
        if (data.presellType === 2) {
          // 检查预售发货时间是否已填写
          const hasPresellDelivery = _timeSpecList && _timeSpecList.length > 0;
          // 如果预售发货时间已填，或者现货发货时间已填，则通过校验
          if (hasPresellDelivery || (value && value.length > 0)) {
            callback();
          } else {
            callback(new Error('现货发货时间和预售发货时间至少填写一个'));
          }
        } else {
          // 非现货+预售模式保持原有校验逻辑
          if (!value) {
            callback(new Error('请选择现货发货时间'));
          } else {
            callback();
          }
        }
    } else {
        callback()
    }
  }
// 校验发货时效
const validateTimeSpecList = (rule, value, callback,context) => {
    if(context._data.timeSkuPresellWithNormalRule && context._data.timeSkuPresellWithNormalRule.support == true){
        let _value =  value?[...new Set(value.map(item => Number(item)))].filter(item => item !== 0) : []
        const data = context._data.value?context._data.value:context._data.formData
        if(_value.length == 1 && [2].includes(Number(_value)) && data.deliveryDelayDay.length == 0){
            _value = []
        }
        // 如果是现货+预售模式
        if (data.presellType === 2) {
            // 检查现货发货时间是否已填写
            const hasDeliveryDelay = data.deliveryDelayDay && data.deliveryDelayDay.length > 0;
            // 如果现货发货时间已填，或者预售发货时间已填，则通过校验
            if (hasDeliveryDelay || (_value && _value.length > 0)) {
            callback();
            } else {
            callback(new Error('现货发货时间和预售发货时间至少填写一个'));
            }
        } else {
            callback();
        }
    } else {
        if (!value || !value.length) {
            return callback(new Error('请选择预售发货时间'))
        }
    }
    callback()
}

const validateReferencePrice = (context) => {
    const { isRequired = false } = context.referencePriceRule || {};
    const validFunc =  (rule, value, callback, context) => {
        const { isRequired, lowerSkuPriceTimes } = context.referencePriceRule;
        if (!value && isRequired) {
            return callback(new Error('请输入参考价'));
        } else if (!value) {
            return callback();
        }
        const minPrice = _.minBy(context.skuList, (item) => {
            return item.price;
        })?.price || 0;

        const tableMaxPrice = _.maxBy(context.skuList, (item) => {
            return item.price;
        })?.price || 0;

        if (minPrice === 0 || tableMaxPrice === 0) {
            return callback();
        }
        if (lowerSkuPriceTimes) {
            const maxPrice = (minPrice * lowerSkuPriceTimes).toFixed(3);
            if (value > Number(maxPrice)) {
                return callback(new Error(`参考价不能大于SKU最低价格的${lowerSkuPriceTimes}倍`));
            }
        }
        if (value < Number(tableMaxPrice)) {
            return callback(new Error(`参考价需大于等于最高售卖价`));
        }
        return callback();
    }
    return [
        { required: isRequired, message: '请输入参考价' },
        {validator: contextWrap(validFunc, context), trigger: 'change'},
    ]
}
const validateSizePicUrlRule = async (rule, value, callback, context) => {
    if(context.$refs.sizePicUrl) {
        let errMsg = await context.$refs.sizePicUrl.method_validImage();
        if (errMsg) {
            callback(new Error(errMsg));
        } else {
            callback();
        }
    } else {
        callback();
    }
}

// 若需要vm上下文请用此函数包裹
function contextWrap(fn, context, refName) {
    return (rule, value, callback) => fn(rule, value, callback, context, refName);
}

const RULES = function(context) {
    return {
        categoryIds: [
            {required: true, message: '请选择类目', trigger: 'change'},
            {validator: validateCategoryIds}
        ],
        name: [
            {required: true, message: '请输入标题', trigger: 'blur'},
            {validator: contextWrap(validateTitle, context), trigger: 'blur'},
        ],
        shortTitle: [
            {validator: contextWrap(validateShortTitle, context), trigger: 'blur'},
        ],
        recommendRemark: [
            {validator: validateDescrip, trigger: 'change'},
        ],
        pic: [
            {required: true, message: '至少要选择3张图片'},
            {validator: contextWrap(validatePic, context), trigger: 'change'},
        ],
        dialogImageUrl: [
            {validator: contextWrap(validateDialogImageUrl, context), trigger: 'change'},
        ],
        ...['mainImages34', 'guideImg'].reduce((acc, k) => ({
            ...acc,
            [k]: [
                { required: false, message: '' },
                { validator: contextWrap(validatePic34, context, k), trigger: 'change' },
            ]
        }), {}),
        description: [
            {required: true, message: '至少要选择1张图片'},
            {validator: contextWrap(validateImages, context), trigger: 'change'},
        ],
        presellEndTime: [
            // {required: true, message: '请选择预售结束时间'},
            {validator: contextWrap(validatePresellEnd, context)}
        ],
        presellDelay: [
            {required: true, message: '请输入发货时间'},
        ],
        shipsDays: [
            {required: true, message: '请输入发货时间'},
        ],
        payType: [
            {required: true, message: '请选择支付方式'},
        ],
        reduceType: [
            {required: true, message: '请选择库存计数方式'}
        ],
        supplyDayReturnSelector: [
            {required: true, message: '请选择无理由退货服务'},
            {validator: contextWrap(validateSupplyDayReturnSelector, context), trigger: 'change'}
        ],
        limitPerBuyer: [
            {validator: contextWrap(validateLimitPB, context), trigger: 'blur'}
        ],
        maximumPerOrder: [
            {validator: contextWrap(validateMaxPO, context), trigger: 'blur'}
        ],
        minimumPerOrder: [
            {validator: contextWrap(validateMinPO, context), trigger: 'blur'}
        ],
        mobile: [
            {validator: validateKefuPhone}
        ],
        marketPrice: [
            {required: true, message: '请输入划线价'},
            {validator: validatePrice, trigger: 'change'}
        ],
        // discountPrice: [
        //     {required: true, message: '请输入售卖价'},
        //     {validator: validatePrice, trigger: 'change'}
        // ],
        referencePrice: validateReferencePrice(context),
        'referencePriceCertificate.certificate_type': [
            { required: true, message: '请选择参考价凭证类型' }
        ],
        'referencePriceCertificate.certificate_urls': [
            { required: true, message: '请上传参考价凭证图' },
            {validator: contextWrap(validateCertificateImages, context), trigger: 'change'},
        ],
        
        deliveryDelayDay: [
            { 
                validator: contextWrap(validateDeliveryDelayDay, context),
              }
        ],
        timeSpecList: [
            {
                validator: contextWrap(validateTimeSpecList, context),
            }
        ],
        isOnshelf: [{ required: true, message: '请输入上架设置', trigger: 'change' }],
        
        sizePicUrl: [
            { validator: contextWrap(validateSizePicUrlRule, context)}
        ],
        // weight: [
        //     {required: true, message: '请输入重量'},
        //     {validator: validateWeight, trigger: 'change'}
        // ],
    };
}
const validateSkuPrice = (value, prop) => {
    value = String(value).trim();
    const valueNum = Number(value);
    const idx = value.lastIndexOf('.');
    const mStr = value.slice(idx+1);
    if (value === '') {
        return prop.label + '不能为空值!'
    } else if (isNaN(valueNum)) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else if (valueNum <= 0) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else if (idx !== -1 &&  mStr.length > 2) {
        return prop.label + '必须为大于等于0的正数且支持小数点后2位';
    } else {
        return false;
    }
}

const validateSkuPicture = (value, prop, context, sku) => {
    let skuPictureRule = context?.skuPictureRule || {};
    let skuList = context?.skuList || [];
    const { requireType } = skuPictureRule;

    // 获取当前 SKU 的 skuPictureUrl 值
    const skuPictureUrl = sku?.skuPictureUrl;

    // 必填校验 - 检查当前 SKU 是否未上传图片
    if(requireType === 1 && (!skuPictureUrl || skuPictureUrl === '')) {
        return prop.label + '为必填项，请上传图片!';
    }

    // 检查图片校验错误信息（宽高比、大小等）
    if(sku.skuPictureErrMsg) {
        return sku.skuPictureErrMsg;
    }

    // 必填校验 - 根据 requireType 校验
    if(requireType === 1) {
        // requireType === 1: 所有 SKU 都必须上传图片
        let urlList = skuList.filter(sku => sku.skuPictureUrl);
        if(urlList.length !== skuList.length) {
            return prop.label + '所有 SKU 都必须上传图片!';
        }
    } else if(requireType === 2) {
        // requireType === 2: 必须全部上传或者全部删除
        let urlList = skuList.filter(sku => sku.skuPictureUrl);
        if(urlList.length && urlList.length !== skuList.length) {
            return prop.label + '必须全部上传或者全部删除！';
        }
    }

    let errorList = skuList.filter(sku => sku.skuPictureErrMsg)
    if(errorList.length){
        return prop.label + errorList[0].skuPictureErrMsg;
    }

    return false;
}

const getSizeTypeRules = (context) => {
    const rules = []
    if(context.componentTemplateRule.mustInput) {
        rules.push({required: true, message: '请选择尺码信息'})
    }
    return rules
}


const getSizeTemplateConfRules = (context) => {
    const rules = []
    if(context.componentTemplateRule.mustInput) {
        rules.push({required: true, message: '店铺尺码表必填'})
    }
    return rules
}
const getHomeInstallServiceTemplateIdRules = (context) => {
    const rules = []
    if(context.homeInstallServiceRule.options?.length) {
        rules.push({required: context.homeInstallServiceRule.mustSelect, message: '请选择安装模式'})
    }
    return rules
}

const getShippingOriginInfoRules = (context) => [{
    trigger: 'change',
    validator: (rule, value, callback) => {
        if (!context.shippingOriginRule.mustSelect) {
            callback();
            return;
        }
        if (!value?.shippingOriginType) {
            callback(new Error('请选择发货地类型'));
            return;
        }
        if (value.shippingOriginId === '' || value.shippingOriginId === null || value.shippingOriginId === undefined) {
            callback(new Error(context.shippingOriginOptions?.length ? '请选择发货地' : '请创建发货地，发货地仅支持通过抖店后台创建'));
            return;
        }
        callback();
    }
}]



export {
    RULES as default,
    validateSkuPrice,
    getSizeTypeRules,
    getSizeTemplateConfRules,
    getHomeInstallServiceTemplateIdRules,
    getShippingOriginInfoRules,
    validateSkuPicture,
}
